import React from 'react';
import RecompenseStatusBadge from './RecompenseStatusBadge';
import { toRecompenseCardView } from '../../utils/recompensePresentation';

/**
 * Mini-carte coup d’œil — catalogue réel uniquement.
 * Affiche le coût exact via formatCoutPoints (ex. « 100 points »).
 */
export default function RecompenseGlanceCard({ recompense, index = 0 }) {
  const card = toRecompenseCardView(recompense, index);
  const accent =
    card.family === 'montant'
      ? 'bg-emerald-50 text-emerald-700 border-emerald-100'
      : card.family === 'pourcent'
        ? 'bg-sky-50 text-sky-700 border-sky-100'
        : 'bg-purple-50 text-[#4A148C] border-purple-100';

  return (
    <div
      className="rounded-2xl border border-gray-200 bg-white p-3.5 shadow-sm min-w-[8.5rem] max-w-[11rem] flex-1"
      data-testid="recompense-glance-card"
    >
      <div className="flex items-start justify-between gap-2">
        <div
          className={`inline-flex items-center justify-center rounded-xl border px-2.5 py-1.5 text-lg font-bold leading-none ${accent}`}
          data-testid="recompense-glance-hero"
        >
          {card.hero}
        </div>
        <RecompenseStatusBadge code={card.statut.code} label={card.statut.label} />
      </div>
      <p className="mt-2.5 text-sm font-semibold text-gray-900 leading-snug line-clamp-2" title={card.effectLabel}>
        {card.effectLabel}
      </p>
      <p className="mt-1 text-xs text-gray-600">{card.coutLabel}</p>
    </div>
  );
}
